import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  AddEcosDebriefPictureResult,
  EcosDebriefResult,
} from '../../../shared/models/api-results/ecos-debrief.api-result';
import {
  UpdateEcosDebriefPayload,
  AddEcosDebriefPicturePayload,
  AddEcosDebriefVideoPayload,
} from '../../../shared/models/payloads/ecos-debrief.payload';
import { convertToFormData } from '../../../shared/utils/api-transformations';
import { AddedEntity } from '../../../shared/models/api-results/base.api-result';

@Injectable({
  providedIn: 'root',
})
export class HttpEcosDebriefService {
  constructor(private http: HttpClient) {}

  getDebrief(id: string) {
    return this.http
      .get(
        `${environment.api_base_url}/exam_contents_ecos/${id}/get_debriefing_of_an_exam_content_ecos`
      )
      .pipe(map((res) => res as EcosDebriefResult));
  }

  wUpdateDebrief(id: string, payload: UpdateEcosDebriefPayload) {
    return this.http.post(
      `${environment.api_base_url}/exam_contents_ecos/update_exam_content_ecos_debriefing/${id}`,
      payload
    );
  }

  wAddDebriefPicture(id: string, payload: AddEcosDebriefPicturePayload) {
    return this.http
      .post(
        `${environment.api_base_url}/ecos_debriefing_pictures/add_ecos_debriefing_picture/${id}`,
        convertToFormData(payload)
      )
      .pipe(map((res) => res as AddEcosDebriefPictureResult));
  }

  wDeleteDebriefPicture(id: string) {
    return this.http.post(
      `${environment.api_base_url}/ecos_debriefing_pictures/delete_ecos_debriefing_picture/${id}`,
      {}
    );
  }

  wAddDebriefVideo(id: string, payload: AddEcosDebriefVideoPayload) {
    return this.http
      .post(
        `${environment.api_base_url}/ecos_debriefing_videos/add_ecos_debriefing_video/${id}`,
        payload
      )
      .pipe(map((res) => res as AddedEntity));
  }

  wDeleteDebriefVideo(id: string) {
    return this.http.post(
      `${environment.api_base_url}/ecos_debriefing_videos/delete_ecos_debriefing_video/${id}`,
      {}
    );
  }
}
